import { createWithI18n } from '@post-office/placement-common-v2/i18n';

import { messagesLoader as growthTransmuters} from '@post-office/team-package--i18n--growth-transmuters';

export const withI18n = createWithI18n(growthTransmuters);